import moment from 'moment';
import * as types from '../constants';

const INITSTATE = {
  expiration: '',
  reservations: [],
  showTimer: false,
  hasError: false,
  account_id: '',
  subtotal: '0',
  discount: '0',
  tax: '0',
  total: '0',
  showSessionWarning: false,
  err_message: ''
};

export default function cart(state = INITSTATE, action) {
  const st = Object.assign({}, state);
  const maxDuration = moment.duration(types.MAX_SESSION_HOURS, 'hours');
    switch (action.type) {
    case types.GET_CART:
      const reservations = [...action.payload.reservations, ...action.payload.untimed_reservations];
      st.hasError = false;
      for (const res of reservations) {
        if (res.errors) {
            st.hasError = true;
            break;
        }
      }
      st.expiration = action.payload.expiration;
      st.reservations = reservations;
      st.showTimer = (action.payload.reservations.length > 0);
      st.account_id = action.payload.account_id;
      st.subtotal = action.payload.subtotal;
      st.discount = action.payload.discount;
      st.tax = action.payload.tax;
      st.total = action.payload.total;
      st.showSessionWarning = (moment(st.session).add(maxDuration) < moment(st.expiration));
      delete st.err;
      return st;

    case types.ADD_ITEM:
      return st;

    case types.CART_ERROR:
      st.err_message = action.payload;
      delete st.err;
      return st;

    case types.REMOVE_RESERVATION_ERROR:
      st.err_message = action.payload;
      delete st.err;
      return st;

    case types.LOGOUT_SUCCESS:
      return INITSTATE;

    default:
      return st;
  }
}
